import React from 'react';
import PropTypes from 'prop-types';
import DealerLP from '@components/DealerLP/DealerLP';
import LocationsStateListing from '@components/Locations/LocationsStateListing';
import {
  getDealerLandingPageInfo,
  getDealerAvailableModels,
  getDealerInventoryModels,
  getCityStateDealerListingsByState,
} from '@services/dealerService';
import { getAbbreviatedState } from '@utils/stateUtils';
import { getWebsiteAreaContent } from '@services/contentfulService';

const websiteAreaStatePageContentfulKey = '44Cmg3gcMT1R8Kms5LPRY8'; //State Page WAC
const websiteAreaDealerLandingPageContentfulKey = '1HtkkneAs8Vg2QtA90f9eY'; //DLP WAC

const LocationsRouter = ({
  dealerInfo,
  dealerSlug,
  availableModels,
  inventoryModels,
  websiteAreaContent,
  locationsListByState,
  fullStateName,
}) => {
  // if a state is part of the URL, we send the user to the states page (example slug: /locations/tennessee)
  // if the slug is not a valid state, we send the user to the dealer landing page (example slug: locations/clayton-homes-knoxville)
  // if the slug isn't a valid state or DLP slug, we'll send them to the 404 page (example slug: locations/lksdjflksdjfl)
  // note: checking validity of the DLP slug will be handled with the DLP work
  if (
    fullStateName &&
    fullStateName !== null &&
    websiteAreaContent &&
    websiteAreaContent !== null &&
    locationsListByState &&
    locationsListByState !== null
  ) {
    return (
      <LocationsStateListing
        fullStateName={fullStateName}
        websiteAreaContent={websiteAreaContent}
        locationsListByState={locationsListByState}
      />
    );
  } else if (dealerSlug) {
    return (
      <DealerLP
        dealerSlug={dealerSlug}
        ssrDealerInfo={dealerInfo}
        ssrWebsiteAreaContent={websiteAreaContent}
        ssrAvailableModels={availableModels}
        ssrInventoryModels={inventoryModels}
      />
    );
  } else {
    return null;
  }
};

LocationsRouter.propTypes = {
  availableModels: PropTypes.any,
  dealerInfo: PropTypes.any,
  dealerSlug: PropTypes.any,
  fullStateName: PropTypes.any,
  inventoryModels: PropTypes.any,
  locationsListByState: PropTypes.any,
  websiteAreaContent: PropTypes.any,
};

export async function getServerSideProps({ params }) {
  let wac = null;
  let locations = null;
  let dealerInfo = null;
  let availableModels = null;
  let inventoryModels = null;
  let dealerNotFound = false;

  if (params.state_or_dlp_slug === 'future-homes-of-tacoma') {
    params.state_or_dlp_slug = 'american-home-center';
  }

  if (getAbbreviatedState(params.state_or_dlp_slug)) {
    await getWebsiteAreaContent(websiteAreaStatePageContentfulKey).then(
      (result) => {
        wac = result;
      }
    );

    await getCityStateDealerListingsByState(
      getAbbreviatedState(params.state_or_dlp_slug)
    ).then((result) => {
      locations = result;
    });

    return {
      props: {
        websiteAreaContent: wac,
        locationsListByState: locations,
        fullStateName: params.state_or_dlp_slug.replace('-', ' '),
      },
    };
  } else {
    await Promise.allSettled([
      getWebsiteAreaContent(websiteAreaDealerLandingPageContentfulKey)
        .then((result) => (wac = result))
        .catch(() => {}),

      getDealerLandingPageInfo(params.state_or_dlp_slug)
        .then((result) => (dealerInfo = result))
        .catch(() => {
          dealerNotFound = true;
        }),
      getDealerAvailableModels({ dealerSlug: params.state_or_dlp_slug })
        .then((result) => {
          availableModels = result;
        })
        .catch((e) => {
          console.log(e);
        }),
      getDealerInventoryModels({ dealerSlug: params.state_or_dlp_slug })
        .then((result) => {
          inventoryModels = result;
        })
        .catch((e) => {
          console.log(e);
        }),
    ]);

    if (dealerNotFound) {
      return {
        notFound: true,
      };
    }

    if (
      dealerInfo != null &&
      params.state_or_dlp_slug === 'american-home-center'
    ) {
      dealerInfo.dealer.dealerName = 'Future Homes of Tacoma';
    }

    return {
      props: {
        dealerSlug:
          params.state_or_dlp_slug === 'american-home-center'
            ? 'future-homes-of-tacoma'
            : params.state_or_dlp_slug,
        dealerInfo: dealerInfo,
        availableModels: availableModels,
        inventoryModels: inventoryModels,
        websiteAreaContent: wac,
      },
    };
  }
}

export default LocationsRouter;
